<template lang="pug">
.notifyStats
    v-card(light, flat)
        v-container
            v-row
                v-spacer
                v-col
                    v-row
                        v-col.d-flex
                            v-btn(:color="activeButton === 'lastMonth' ? 'brand' : 'white'"
                                :class="{'active-btn': activeButton === 'lastMonth'}"
                                @click="setActive('lastMonth')") Last Month
                            v-btn.ml-4(:color="activeButton === 'currentMonth' ? 'brand' : 'white'"
                                :class="{'active-btn': activeButton === 'currentMonth'}"
                                @click="setActive('currentMonth')") Current Month
                            datepicker.ml-4(label='Start Date', v-model='startDate')
                            datepicker.ml-4(label='End Date', v-model='endDate')
                            v-btn.ml-4(:color="activeButton === 'dateRange' ? 'brand' : 'white'"
                                :class="{'active-btn': activeButton === 'dateRange'}"
                                @click="setActive('dateRange')") Date Range
    v-card(light, flat)
        v-container
            v-data-table(
                :headers="overviewheaders"
                :items="overviewData"
                sort-by="customer"
                light,
                @click:row='viewCustomerData'
                fixed-header,
                disable-pagination,
                hide-default-footer,
                height='60vh'
            )
            v-overlay(v-if="loading", absolute)
                .h3 Loading data in Progress....
                br
                v-progress-circular(indeterminate size="128" color="brand")
    v-card(light, flat)
        v-container
            v-row.align-center
                v-spacer

                v-btn(
                    @click="firstPageNumber()"
                ) <<
                v-btn(
                    @click="decrementPageNumber()"
                ) <

                span.page-count Page: {{pageNumber+1}} of {{totalPages+1}}

                v-btn(
                    @click="incrementPageNumber()"
                ) >
                v-btn(
                    @click="lastPageNumber()"
                ) >>
                v-spacer
    v-spacer

    v-bottom-sheet(v-model='selectedCustomerDialog', fullScreen, light, scrollable)
        v-card(light, flat)
            v-card-title {{currentCustomer}}
            v-spacer
                v-data-table(
                    :headers="singleheaders"
                    :items="singleData"
                    sort-by="description"
                    light,
                    fixed-header,
                    disable-pagination,
                    hide-default-footer,
                    height='70vh'
                )
            v-card-actions
                v-btn(color='blue darken-1', text, @click='selectedCustomerDialog = false') Close
</template>

<script>
import datepicker from '../common/datepicker.vue';
export default {
    components: { datepicker

    },
    data () { return {
        accessKey: 'devopsnotifystats',
        startDate:null,
        endDate:null,
        selectedCustomerDialog: false,
        currentCustomer: null,
        pageNumber: 0,
        totalPages: 0,
        newText: 'Help me',
        displayedInfo: [],
        loading: false,
        activeButton: 'currentMonth',
        lastActiveButton: null,
        overviewheaders: [
            {text: 'Customer', value: 'customerData.Name'},
            {text: 'State', value: 'customerData.State'},
            {text: 'Calls', value: 'twilioCalls'},
            {text: 'SMS', value: 'twilioSMS'},
            {text: 'Total Cost', value: 'twilioTotalCost'},
            // {text: 'SparkPost Email', value: 'sparkPostCount'},
            // {text: 'Firebase Push', value: 'fireBaseCount'}
        ],
        singleheaders: [
            {text: 'Description', value: 'description'},
            {text: 'Usage', value: 'usage'},
            {text: 'Price', value: 'price'}
        ]
    };

    },
    methods: {
        setActive (button) {
            this.activeButton = button;
        },
        firstPageNumber (){
            this.pageNumber=0;
        },
        incrementPageNumber (){
            if(this.pageNumber< this.totalPages){
                this.pageNumber++;
            }
        },
        decrementPageNumber (){
            if(this.pageNumber!=0){
                this.pageNumber--;
            }
        },
        lastPageNumber (){
            this.pageNumber=this.totalPages;
        },
        viewCustomerData (item) {
            this.currentCustomer = item.customerData.Name;
            this.selectedCustomerDialog = true;
        },
        getTwilioUsage (data, type) {
            console.log("usage data = ", data);
            if(!Array.isArray(data)){
                return data;
            }
            const item = data.find(d => d.description === type);
            return item ? item.usage : 0;
        },
        async commandTrigger () {
            this.loading = true;

            const allData = await this.sendCommand({
                action: 'getAllNotifyStats',
                parameters: {
                    activeButton: this.activeButton,
                    endDate: this.endDate,
                    startDate: this.startDate,
                    pageNumber: this.pageNumber
                }
            });
            this.displayedInfo = allData.dataForUI;
            this.totalPages = allData.numPages;

            this.loading = false;

        }
    },
    meta: {
        role: 'devopsnotifystats'
    },
    mounted () {
        this.commandTrigger();
    },
    watch:{
        activeButton (oldVal, newVal) {
            this.commandTrigger();
        },

        pageNumber (oldval, newval){
            this.commandTrigger();
        }
    },
    computed: {

        overviewData () {
            return this.displayedInfo.map(entry => ({
                customerData: entry.customerData[0],
                twilioCalls: this.getTwilioUsage(entry.twilioData, 'Outbound Voice Minutes'),
                twilioSMS: this.getTwilioUsage(entry.twilioData, 'Standard Outbound SMS'),
                twilioTotalCost: this.getTwilioUsage(entry.twilioData, 'Total Price'),
                sparkPostCount: entry.sparkPostData[0]?.CountDelivered || 0,
                fireBaseCount: entry.fireBaseData[0]?.CountDelivered || 0
            }));

        },
        singleData () {
            if (!this.currentCustomer) return [];
            const customer = this.displayedInfo.find(entry => entry.customerData[0].Name === this.currentCustomer);
            if (!customer.twilioData) return [];
            return [
                ...customer.twilioData.map(d => ({
                    description: d.description,
                    usage: d.usage,
                    price: d.price
                })),
                { description: "SparkPost Email", usage: customer.sparkPostData[0]?.CountDelivered || 0, price: "-" },
                { description: "Firebase Push", usage: customer.fireBaseData[0]?.CountDelivered || 0, price: "-" }
            ];
        }
    }
};
</script>+

<style scoped>
.v-btn {
  color: 'brand';
  margin: 5px;
  transition: background-color 0.2s;
}

.active-btn {
  color: white  !important;
}

.page-count{
    margin-left: 10px;
    margin-right: 10px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 450;

}

</style>
